export const APP_STORE_URL = 'https://apps.apple.com/am/app/murakami-city/id6752930219';

export const PLAY_STORE_URL =
	'https://play.google.com/store/apps/details?id=com.conceptstudio.murakamicity';
